import { read } from 'utils/Api';

const linkField = ({
  token, entity, entityID, value,
}) =>
  read({
    entity,
    entityID,
    headers: { Authorization: `Bearer ${token}` },
  }).then(e => e.data[value]);

export default linkField;



// WEBPACK FOOTER //
// ./src/utils/linkField.js